import React, { useState } from 'react';
import Context from './Context';
import FrameworkReview from './Frameworkreview';

const ArchitectureAnalysis = () => {
  const [activeTab, setActiveTab] = useState('context');

  return (
    <div className="min-h-screen p-4 w-full bg-black/20">
      {/* Remove max-w-7xl and mx-auto */}
      <div className="w-full">
        {/* Header */}
        <div className="mb-8 px-6 mt-6 ">
          <h1 className="text-3xl font-bold text-white ">
            Application Context
          </h1>
        </div>

        {/* Tab Navigation */}
        <div className="flex gap-1 mb-6 border-b border-gray-700 px-6">
          <button
            onClick={() => setActiveTab('context')}
            className={`px-6 py-3 font-medium transition-all ${
              activeTab === 'context'
                ? 'text-blue-400 border-b-2 border-blue-400'
                : 'text-gray-400 hover:text-gray-300'
            }`}
          >
            Context
          </button>
          <button
            onClick={() => setActiveTab('framework')}
            className={`px-6 py-3 font-medium transition-all ${
              activeTab === 'framework'
                ? 'text-blue-400 border-b-2 border-blue-400'
                : 'text-gray-400 hover:text-gray-300'
            }`}
          >
            Framework Review
          </button>
        </div>

        {/* Tab Content */}
        <div className="bg-black/20 backdrop-blur-sm rounded-lg border border-gray-800 p-6 mx-0">
          {activeTab === 'context' ? <Context /> : <FrameworkReview />}
        </div>
      </div>
    


      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default ArchitectureAnalysis;
